import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const moneyBadgeContainer = style({
  ...typography.labelMd,
  display: 'flex',
  gap: space.s4,
  alignItems: 'center',
  borderRadius: `${borderRadius.r4}px`,
  border: 0,
  width: 'fit-content',
  paddingLeft: space.s8,
  paddingRight: space.s8,
  paddingTop: space.s4,
  paddingBottom: space.s4,
  userSelect: 'none',
  outline: `1px solid ${themeVars.container.border.default}`,
  outlineOffset: '-1px',
  color: themeVars.container.foreground.primary,
});

export const moneyBadgeIcon = style({
  display: 'flex',
  alignItems: 'center',
});
